import React, { useState, useEffect, useRef } from 'react';
import { useHelpPanelLink } from '@atlassian/jira-help-panel-button';
import { useIntl } from '@atlassian/jira-intl';
import { getUrls, ANALYTICS_CHANNEL } from '@atlassian/jira-proforma-utils';
import { toProformaEnvironment } from '@atlassian/jira-proforma-utils/src/common/utils/to-proforma-environment/index.tsx';
import { useProjectContext } from '@atlassian/jira-providers-project-context';
import { JsmPageInteractiveEvent } from '@atlassian/jira-servicedesk-common/src/utils/browser-metric/index.tsx';
import { useAccountId } from '@atlassian/jira-tenant-context-controller/src/components/account-id/index.tsx';
import { useCloudId } from '@atlassian/jira-tenant-context-controller/src/components/cloud-id/index.tsx';
import { useEnvironment } from '@atlassian/jira-tenant-context-controller/src/components/environment/index.tsx';
import type { BackendSettings } from '@atlassian/proforma-common-core/jira-common-models';
import {
	JiraIssueFormsGeneralApp,
	type JiraIssueFormsGeneralSettings,
} from '@atlassian/proforma-jira-issue-forms/general';

const ProformaJiraIssueFormsGeneral = () => {
	const accountId = useAccountId();
	const cloudId = useCloudId();
	const environment = useEnvironment();
	const { locale } = useIntl();
	const { data: projectContext } = useProjectContext();
	const { simplified } = projectContext ?? {};
	const [settings, setSettings] = useState<BackendSettings<JiraIssueFormsGeneralSettings>>();
	const onOpenInProductHelpArticle = useRef(useHelpPanelLink());

	useEffect(() => {
		setSettings({
			analytics: { channel: ANALYTICS_CHANNEL },
			flags: {},
			urls: getUrls(environment, cloudId),
			environment: toProformaEnvironment(environment),
			context: {
				inProductHelpData: {
					simplifiedProject: simplified ?? false,
					onOpenInProductHelpArticle: (articleId: string) => {
						if (onOpenInProductHelpArticle.current) {
							onOpenInProductHelpArticle.current(articleId);
						}
					},
				},
				intlLocale: locale,
			},
		});
	}, [cloudId, environment, locale, simplified]);
	return settings ? (
		<>
			<JiraIssueFormsGeneralApp settings={settings} reporterAccountId={accountId ?? undefined} />
			<JsmPageInteractiveEvent />
		</>
	) : null;
};

export default ProformaJiraIssueFormsGeneral;
